import type { Breakpoint } from 'antd';
import type { NavItem } from 'configs/NavigationConfig';

class Utils {
  static getRouteInfo(
    navTrees: NavItem[],
    path: string
  ): { key: string; title: string } | undefined {
    let route;
    navTrees.forEach((navTree) => {
      if (navTree.path === path) {
        route = { key: navTree.key, title: navTree.title };
      }
      if (navTree.submenu) {
        const subRoute = this.getRouteInfo(navTree.submenu, path);
        if (subRoute) {
          route = subRoute;
        }
      }
    });
    return route;
  }

  static getBreakPoint(screens: Partial<Record<Breakpoint, boolean>>) {
    const breakpoints = [];
    for (const key in screens) {
      if (key in screens) {
        const element = screens[key as Breakpoint];
        if (element) {
          breakpoints.push(key);
        }
      }
    }
    return breakpoints;
  }
}

export default Utils;
